import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "aside-logo flex-column-auto",
  id: "kt_aside_logo"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/logos/hc.svg",
  class: "h-35px logo"
}, null, -1)
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "aside-menu flex-column-fluid" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "aside-footer flex-column-auto pt-5 pb-7 px-5",
  id: "kt_aside_footer"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HcIcon = _resolveComponent("HcIcon")!
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_aside",
    class: _normalizeClass(["aside aside-hoverable", [
      !_ctx.isToggleActive && 'aside-hoverable',  // Apenas com hover quando não ativo
      _ctx.isToggleActive && 'aside-fixed',        // Fixo quando ativo
      _ctx.asideTheme === 'light' && 'aside-light',
      _ctx.asideTheme === 'dark' && 'aside-dark',
    ]]),
    "data-kt-drawer": "true",
    "data-kt-drawer-name": "aside",
    "data-kt-drawer-activate": "{default: true, lg: false}",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
    "data-kt-drawer-direction": "start",
    "data-kt-drawer-toggle": "#kt_aside_mobile_toggle"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.asideTheme === 'dark')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.asideTheme === 'light')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                alt: "Logo",
                src: _ctx.lightLogo,
                class: "h-25px logo"
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        id: "kt_aside_toggle",
        class: "btn btn-icon aside-toggle hc-aside-toggle",
        "data-kt-toggle": "true",
        "data-kt-toggle-state": "active",
        "data-kt-toggle-target": "body",
        "data-kt-toggle-name": "aside-minimize",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAside && _ctx.toggleAside(...args)))
      }, [
        _createVNode(_component_HcIcon, {
          name: "chevrons-left",
          size: 18,
          style: _normalizeStyle({ transform: _ctx.isToggleActive ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.2s ease' })
        }, null, 8, ["style"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_KTMenu, { isToggleActive: _ctx.isToggleActive }, null, 8, ["isToggleActive"])
    ]),
    _hoisted_5
  ], 2))
}